import { useEffect } from "react";
import RegisterForm from "../components/Views/RegisterForm";
import { useModalExit } from "../components/Controls/useModalExit";
import { ModalBusyProvider, ModalBusyOverlay, useModalBusy } from "../components/Controls/modalBusy";

function RegisterModalChrome({ onSwitchToLogin, requestClose, exiting }) {
  const { busy } = useModalBusy();
  const safeClose = () => {
    if (busy) return;
    requestClose();
  };

  useEffect(() => {
    if (exiting) return undefined;
    function onKeyDown(e) {
      if (e.key === "Escape") safeClose();
    }
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [exiting, busy, requestClose]);

  return (
    <div
      className={`mkt-login-overlay${exiting ? " is-exiting" : ""}`}
      role="dialog"
      aria-modal="true"
      aria-busy={busy}
      aria-labelledby="mkt-register-title"
    >
      <button
        type="button"
        className="mkt-login-backdrop"
        aria-label="Close register"
        onClick={safeClose}
        disabled={busy}
      />
      <div className={`mkt-login-dialog mkt-login-dialog--register${busy ? " is-busy" : ""}`}>
        <div className="mkt-login-dialog__header">
          <h2 id="mkt-register-title">Create Account</h2>
          <button
            type="button"
            className="mkt-login-dialog__close"
            aria-label="Close"
            onClick={safeClose}
            disabled={busy}
          >
            ×
          </button>
        </div>
        <div className="mkt-login-dialog__body">
          <RegisterForm
            embedded
            onClose={requestClose}
            onSwitchToLogin={onSwitchToLogin}
          />
        </div>
        <ModalBusyOverlay />
      </div>
    </div>
  );
}

export default function RegisterModal({ onClose, onSwitchToLogin }) {
  const { rendered, exiting, requestClose } = useModalExit({ open: true, onClose });
  if (!rendered) return null;
  return (
    <ModalBusyProvider>
      <RegisterModalChrome
        onSwitchToLogin={onSwitchToLogin}
        requestClose={requestClose}
        exiting={exiting}
      />
    </ModalBusyProvider>
  );
}
